import { Fragment, useContext } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { navigateToUrl } from "single-spa";
import { AppContext } from "../../../../app.context";
import { LoginFormContext } from "../login-form.context";
import { TextLinkComponent, TypographyComponent } from "@gx1/gx-ui-common";
import LoginButton from "../login-button/login-button.component";
import styles from "./first-time-login.module.scss";
import { useUserState } from "@gx1/gx-npm-lib";
import { useRedirect } from "../../../../hooks/use-redirect.hook";

const FirstTimeLogin = () => {
  const { t } = useTranslation();
  const { firstName, lastName, isOnboarded } = useUserState();
  const { setShowMobileMessage, setShowOnboardingExperience } = useContext(AppContext);
  const { setShowSso } = useContext(LoginFormContext);
  const { redirect } = useRedirect();

  const onClickButtonSwitchAcct = () => {
    setShowSso(false);
    window.eventBus.publish("CLEAR_USER_STATE");
    window.eventBus.publish("WS_DISCONNECT");
  };

  const handleSubmit = () => {
    if (isMobile) {
      setShowMobileMessage(true);
      return;
    }
    if (isOnboarded) {
      navigateToUrl(redirect);
      return;
    }
    setShowOnboardingExperience(true);
  };

  return (
    <div aria-label={t("first time user card")} className={styles.firstTimeContainer}>
      <TypographyComponent styling={"h3-xl"} boldness="semi" element="h2" color="grey9">
        {t("Welcome")}
        {firstName && lastName && (
          <Fragment>
            {`, `}
            <br />
            <TypographyComponent styling={"h3-xl"} boldness="semi" color="opal" element="span">
              {`${firstName} `}
              {`${lastName}!`}
            </TypographyComponent>
          </Fragment>
        )}
      </TypographyComponent>
      <TypographyComponent
        styling={"h4"}
        boldness="semi"
        color="grey8"
        element="h3"
        rootClassName={styles.secondHeading}
      >
        {t("As a Gartner client, you have instant access to BuySmart. Let's get you set up.")}
      </TypographyComponent>
      <div className={styles.divider} />
      <div className={styles.switchAccountsContainer}>
        <TypographyComponent styling={"p-sm"} boldness="semi" color="grey9" element="p">
          {`${t("Not")} ${firstName} ${lastName}? `}
        </TypographyComponent>
        <TextLinkComponent
          href={"/login"}
          onClick={onClickButtonSwitchAcct}
          text={t("Switch accounts")}
          variant={"prominent"}
          size={"small"}
        />
      </div>
      <LoginButton onSubmit={handleSubmit} />
    </div>
  );
};

export default FirstTimeLogin;
